/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { WebhookMetadata } from "./WebhookMetadata";
import {
    WebhookMetadataFromJSON,
    WebhookMetadataFromJSONTyped,
    WebhookMetadataToJSON,
} from "./WebhookMetadata";

/**
 *
 * @export
 * @interface WebhookDto
 */
export interface WebhookDto {
    /**
     *
     * @type {number}
     * @memberof WebhookDto
     */
    webhookId?: number;
    /**
     * DeviceStatus: Payload of type DeviceStatusWebhook will be pushed
     * @type {string}
     * @memberof WebhookDto
     */
    webhookType?: WebhookDtoWebhookTypeEnum;
    /**
     *
     * @type {string}
     * @memberof WebhookDto
     */
    accessTag?: string;
    /**
     * By default, the webhook is sent by any device in your organisation. Use this to restrict to a subset of devices (eg a Site)
     * @type {string}
     * @memberof WebhookDto
     */
    deviceGroupTag?: string;
    /**
     * Outgoing uri, either a http(s) or mailto link. When using mailto, additional email addresses can be supplied as a semicolon-sparated list to the 'cc' query param. 'subject' and 'body' params are also supported. Eg: `mailto:first@test.com?cc=second@test.com;third@test.com&subject=My%20NEM12%20data&body=test`
     * @type {string}
     * @memberof WebhookDto
     */
    url?: string;
    /**
     * Max number of times to retry the same payload if a non HTTP-2XX status code is returned, before the payload is dead-lettered. Limit: 9. Use 0 for only one attempt with no retry.
     * @type {number}
     * @memberof WebhookDto
     */
    maxRetries?: number;
    /**
     * Outgoing http headers to be added to the request
     * @type {{ [key: string]: string; }}
     * @memberof WebhookDto
     */
    headers?: { [key: string]: string };
    /**
     *
     * @type {WebhookMetadata}
     * @memberof WebhookDto
     */
    metadata?: WebhookMetadata;
    /**
     *
     * @type {Date}
     * @memberof WebhookDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof WebhookDto
     */
    updatedAt?: Date;
    /**
     * True if this webhook is disabled. Disabled webhooks are retained and listed but not invoked. Settable via update-webhook to disable or re-enable.
     * @type {boolean}
     * @memberof WebhookDto
     */
    isDisabled?: boolean;
}

/**
 * @export
 */
export const WebhookDtoWebhookTypeEnum = {
    DeviceStatus: "DeviceStatus",
    Nem12Report: "Nem12Report",
    TransactionReport: "TransactionReport",
    PayMateStartTransaction: "PayMateStartTransaction",
    PayMateStopTransaction: "PayMateStopTransaction",
    PayMatePaymentConfirmation: "PayMatePaymentConfirmation",
    DeviceConfigurationChange: "DeviceConfigurationChange",
    ChargepointCurtailmentAction: "ChargepointCurtailmentAction",
    UptimeReport: "UptimeReport",
    OfflineDeviceReport: "OfflineDeviceReport",
    FaultedDeviceReport: "FaultedDeviceReport",
    CarbonEmissionReport: "CarbonEmissionReport",
    VehicleReport: "VehicleReport",
} as const;
export type WebhookDtoWebhookTypeEnum =
    (typeof WebhookDtoWebhookTypeEnum)[keyof typeof WebhookDtoWebhookTypeEnum];

/**
 * Check if a given object implements the WebhookDto interface.
 */
export function instanceOfWebhookDto(value: object): value is WebhookDto {
    return true;
}

export function WebhookDtoFromJSON(json: any): WebhookDto {
    return WebhookDtoFromJSONTyped(json, false);
}

export function WebhookDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): WebhookDto {
    if (json == null) {
        return json;
    }
    return {
        webhookId: json["webhookId"] == null ? undefined : json["webhookId"],
        webhookType:
            json["webhookType"] == null ? undefined : json["webhookType"],
        accessTag: json["accessTag"] == null ? undefined : json["accessTag"],
        deviceGroupTag:
            json["deviceGroupTag"] == null ? undefined : json["deviceGroupTag"],
        url: json["url"] == null ? undefined : json["url"],
        maxRetries: json["maxRetries"] == null ? undefined : json["maxRetries"],
        headers: json["headers"] == null ? undefined : json["headers"],
        metadata:
            json["metadata"] == null
                ? undefined
                : WebhookMetadataFromJSON(json["metadata"]),
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        isDisabled: json["isDisabled"] == null ? undefined : json["isDisabled"],
    };
}

export function WebhookDtoToJSON(value?: WebhookDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        webhookId: value["webhookId"],
        webhookType: value["webhookType"],
        accessTag: value["accessTag"],
        deviceGroupTag: value["deviceGroupTag"],
        url: value["url"],
        maxRetries: value["maxRetries"],
        headers: value["headers"],
        metadata: WebhookMetadataToJSON(value["metadata"]),
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        isDisabled: value["isDisabled"],
    };
}
